import { Component } from 'react';
import { Alert, Spinner, Card } from 'react-bootstrap';

import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { connect, batch } from 'react-redux';
import PropTypes from 'prop-types';
import LoginForm from '../components/LoginForm';
import { userService } from '../services';
import { setPolicyLength, setTypesLength } from '../actions/timeOff';
import {
  INVALID_LOGIN,
  LOCAL_STORAGE_USER_DATA,
  LOCAL_STORAGE_USER_STATE,
  GENERAL,
  INVALID_WEB_LOGIN,
} from '../constants';
import hiveDeskLogoBlue from '../assets/img/HiveDesk_Logo_blue.svg';
import { ErrorBoundary, RedirectionAfterLogin } from '../components/common';
import { setAccountStatus, setCurrentPlan } from '../actions/billing';
import {
  setPrivacyAcceptanceStatus,
  setSubscription,
  fetchOnBoardProgress,
  fetchAccountDetails,
} from '../actions/user';
import { fetchTeamMembers } from '../actions/team';
import { fetchNotificationAll } from '../actions/notification';
import { fetchMemberProjects } from '../actions/projects';
import { resetWidget } from '../actions/timer';
import { fetchPendingRequests } from '../actions/requests';
import {
  setSelectedTeam,
  setPermissions,
  setFeatures,
  fetchSites,
} from '../actions/index';
import { trackIntercom } from '../utilities/analytics';

class Login extends Component {
  state = {
    loggedIn: false,
    isSubmitting: false,
    isServerError: '',
    userData: {},
    selectTeam: true,
    isWebLogin: false,
    featuresList: [
      'Create Employee Schedule',
      'Track Overtime ',
      'Approve Timesheets',
      'Track Time Off',
      'Generate Invoices',
      'Create Holiday Calendar',
      'Create Custom Roles',
      'Set Up Clients',
      'Calculate Shrinkage',
      'Track Break Time',
    ],
  };

  componentDidMount() {
    const url = new URL(window.location.href);
    const webCode = url.searchParams.get('key');

    const { search } = window.location;
    const params = new URLSearchParams(search);
    const cnfCode = params.get('cnf');

    if (cnfCode !== null) {
      userService
        .confirm_account({ cnfCode })
        .then((response) => {
          if (response.message === 'Success') {
            toast.success(GENERAL.ACCOUNT_CONFIRM_SUCCESS);
          } else {
            toast.error(response.message);
          }
        })
        .catch(() => {
          toast.error(GENERAL.ACCOUNT_CONFIRM_ERROR);
        });
    }
    if (webCode) {
      const { dispatch } = this.props;
      this.setState((state) => ({
        ...state,
        isWebLogin: true,
      }));
      userService
        .web_login({ webcode: webCode })
        .then((response) => {
          // Remove user details if exists
          localStorage.removeItem(LOCAL_STORAGE_USER_DATA);
          localStorage.removeItem(LOCAL_STORAGE_USER_STATE);

          if (response.userDetails) {
            const userData = response.userDetails;
            // Store user details
            localStorage.setItem(
              LOCAL_STORAGE_USER_DATA,
              JSON.stringify(userData)
            );

            const { teams } = response.userDetails;
            const isDefaultTeam =
              userData.teams.length === 1 ||
              teams.some((team) => team.defaultTeam);
            if (teams.length === 1) {
              // Only one team, select it
              localStorage.setItem('teamOwnerId', teams[0].accountOwnerId);
              dispatch(setSelectedTeam(teams[0]));
              dispatch(setPermissions(teams[0].permissions));
              dispatch(setFeatures(teams[0].features));
              dispatch(
                setPolicyLength({ policyLength: teams[0].timeOffPolicy })
              );
              dispatch(setTypesLength({ typesLength: teams[0].timeOffType }));
              this.setState((state) => ({
                ...state,
                selectTeam: false,
              }));
            } else {
              // Multiple teams, check for a default team
              const defaultTeam = teams.find((team) => team.defaultTeam);

              if (defaultTeam) {
                localStorage.setItem('teamOwnerId', defaultTeam.accountOwnerId);
                dispatch(setSelectedTeam(defaultTeam));
                dispatch(setPermissions(defaultTeam.permissions));
                dispatch(setFeatures(defaultTeam.features));
                dispatch(
                  setPolicyLength({ policyLength: defaultTeam.timeOffPolicy })
                );
                dispatch(
                  setTypesLength({ typesLength: defaultTeam.timeOffType })
                );
                this.setState((state) => ({
                  ...state,
                  selectTeam: false,
                }));
              } else {
                this.setState((state) => ({
                  ...state,
                  selectTeam: true,
                }));
              }
            }

            // Set state
            this.setState((state) => ({
              ...state,
              loggedIn: true,
              isSubmitting: false,
              isWebLogin: false,
              selectTeam: userData.defaultTeam === null,
            }));

            // Dispatch required actions
            // const { dispatch } = this.props;
            batch(() => {
              // dispatch(fetchNotification());
              if (isDefaultTeam) {
                dispatch(fetchNotificationAll());
                dispatch(fetchSites());
                dispatch(
                  setAccountStatus({ accountStatus: userData.userStatus })
                );
                dispatch(
                  setPrivacyAcceptanceStatus({
                    policyAcceptanceStatus: userData.policyAcceptanceStatus,
                  })
                );
                dispatch(setSubscription({ ...userData.subscriptionDetails }));
                dispatch(
                  setCurrentPlan({
                    planName: userData.subscriptionDetails.currentPlan,
                  })
                );
              }
              dispatch(
                fetchPendingRequests({
                  teamOwnerId: localStorage.getItem('teamOwnerId'),
                })
              );
              // Reset timer widget
              dispatch(resetWidget());
            });

            // Check if it is a trail user and update LocalStorage USER_DATA
            if (
              userData.subscriptionDetails.currentPlan !== null &&
              userData.subscriptionDetails.currentPlan.toLowerCase() === 'trial'
            ) {
              dispatch(fetchOnBoardProgress());
            }

            // Get seat count and store to LS
            setTimeout(() => {
              if (isDefaultTeam) {
                dispatch(fetchMemberProjects());
                dispatch(fetchAccountDetails());
              }
            }, 3000);
          }
        })
        .catch((error) => {
          this.setState((state) => ({
            ...state,
            isSubmitting: false,
            loggedIn: false,
            isWebLogin: false,
            isServerError: INVALID_WEB_LOGIN,
          }));
        });
    }
  }

  handleLogin = (formdata) => {
    this.setState((state) => ({
      ...state,
      isSubmitting: true,
    }));

    // Dispatch required actions
    const { dispatch } = this.props;

    userService
      .login({ ...formdata })
      .then((response) => {
        // Remove user details if exists
        localStorage.removeItem(LOCAL_STORAGE_USER_DATA);
        localStorage.removeItem(LOCAL_STORAGE_USER_STATE);
        if (response.userDetails) {
          const userData = response.userDetails;
          // Store user details
          localStorage.setItem(
            LOCAL_STORAGE_USER_DATA,
            JSON.stringify(userData)
          );

          const { teams } = response.userDetails;
          const isDefaultTeam =
            userData.teams.length === 1 ||
            teams.some((team) => team.defaultTeam);
          if (teams.length === 1) {
            // Only one team, select it
            localStorage.setItem('teamOwnerId', teams[0].accountOwnerId);
            dispatch(setSelectedTeam(teams[0]));
            dispatch(setPermissions(teams[0].permissions));
            dispatch(setFeatures(teams[0].features));
            dispatch(setPolicyLength({ policyLength: teams[0].timeOffPolicy }));
            dispatch(setTypesLength({ typesLength: teams[0].timeOffType }));
            this.setState((state) => ({
              ...state,
              selectTeam: false,
            }));
          } else {
            // Multiple teams, check for a default team
            const defaultTeam = teams.find((team) => team.defaultTeam);
            if (defaultTeam) {
              localStorage.setItem('teamOwnerId', defaultTeam.accountOwnerId);
              dispatch(setSelectedTeam(defaultTeam));
              dispatch(setPermissions(defaultTeam.permissions));
              dispatch(setFeatures(defaultTeam.features));
              dispatch(
                setPolicyLength({ policyLength: defaultTeam.timeOffPolicy })
              );
              dispatch(
                setTypesLength({ typesLength: defaultTeam.timeOffType })
              );
              this.setState((state) => ({
                ...state,
                selectTeam: false,
              }));
            } else {
              // No default, navigate to team selection
              this.setState((state) => ({
                ...state,
                selectTeam: true,
              }));
            }
          }

          // Set state
          this.setState((state) => ({
            ...state,
            loggedIn: true,
            isSubmitting: false,
          }));

          batch(() => {
            if (isDefaultTeam) {
              dispatch(fetchNotificationAll());
              dispatch(fetchSites());
              dispatch(
                setAccountStatus({ accountStatus: userData.userStatus })
              );
              dispatch(
                setPrivacyAcceptanceStatus({
                  policyAcceptanceStatus: userData.policyAcceptanceStatus,
                })
              );
              dispatch(setSubscription({ ...userData.subscriptionDetails }));
              dispatch(
                setCurrentPlan({
                  planName: userData.subscriptionDetails.currentPlan,
                })
              );
              dispatch(
                fetchPendingRequests({
                  teamOwnerId: localStorage.getItem('teamOwnerId'),
                })
              );
            }
            // Reset timer widget
            dispatch(resetWidget());
          });
          // Check if it is a trail user and update LocalStorage USER_DATA
          if (
            userData.subscriptionDetails.currentPlan !== null &&
            userData.subscriptionDetails.currentPlan.toLowerCase() === 'trial'
          ) {
            dispatch(fetchOnBoardProgress());
          }

          setTimeout(() => {
            if (isDefaultTeam) {
              dispatch(fetchMemberProjects());
              // Get seat count and store to LS
              dispatch(fetchAccountDetails());
              // Get team members and add to store
              if (
                teams &&
                teams.permissions &&
                teams.permissions.length &&
                teams.permissions.includes('team_member_view')
              ) {
                dispatch(fetchTeamMembers());
              }
            }
          }, 5000);
          trackIntercom('Logged In');
        }
      })
      .catch((error) => {
        this.setState((state) => ({
          ...state,
          isSubmitting: false,
          loggedIn: false,
          isServerError: INVALID_LOGIN,
        }));
      });
  };

  render() {
    const {
      loggedIn,
      isSubmitting,
      isServerError,
      selectTeam,
      isWebLogin,
      featuresList,
    } = this.state;
    document.title = 'Login : HiveDesk';
    /* if default exists */
    if (!selectTeam) {
      return <RedirectionAfterLogin />;
    }
    if (!isSubmitting && loggedIn) {
      return <Redirect to="/team-selection" />;
    }

    return isWebLogin ? (
      <section className="d-flex align-items-center justify-content-center content-loader">
        <Spinner
          animation="border"
          className="text-primary"
          role="status"
          size="md"
        />
      </section>
    ) : (
      <ErrorBoundary>
        <section
          className="d-flex align-items-center bg-auth border-top border-top-2 border-primary"
          style={{ minHeight: '100vh' }}
        >
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-12 col-md-6 col-xl-5 order-md-2 mb-5 mb-md-0 d-none d-md-block">
                <Card className="my-5">
                  <Card.Header>
                    <h2 className="m-0">
                      <strong>Have you tried these new features?</strong>
                    </h2>
                  </Card.Header>
                  <Card.Body className="py-0">
                    <ul className="list-group list-group-flush">
                      {featuresList.map((feature, index) => (
                        <li
                          key={index}
                          className="list-group-item d-flex align-items-center px-0"
                        >
                          <i className="fe fe-check-circle text-primary me-3" />
                          <h4 className="m-0">{feature}</h4>
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-12 col-md-6 col-xl-5 col-xl-5 order-md-1 my-5">
                <Card className="my-5 px-5 pt-4 pb-2">
                  <div className="text-center mb-5 mt-4">
                    <img
                      src={hiveDeskLogoBlue}
                      alt="HiveDesk"
                      className="img-fluid"
                      width="250"
                    />
                  </div>
                  <LoginForm
                    handleLogin={this.handleLogin}
                    isSubmitting={isSubmitting}
                  />
                  {isServerError && (
                    <Alert variant="danger">{isServerError}</Alert>
                  )}
                </Card>
              </div>
            </div>
          </div>
        </section>
      </ErrorBoundary>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(Login);
